<mat-form-field class="measure-field" floatLabel="always">
  <mat-label>{{ placeholder() }}</mat-label>
  <input
    matInput
    [disabled]="true"
    [readonly]="true"
    [value]="(measure$ | async) || 0 | measureFormat: measureUnit()"
  />
</mat-form-field>
<mat-form-field class="unit-field">
  <mat-select
    [value]="measureUnit()"
    [disabled]="auto"
    (selectionChange)="onMeasureUnitChange($event.value)"
  >
    @for (measureUnit of measureUnits; track measureUnit) {
      <mat-option [value]="measureUnit">
        {{ 'igo.geo.measure.' + measureUnit | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
